import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { register, formatApiErrorDetail } from "../lib/api";
import { GoogleButton, routeForUser } from "./Login";
import "../studio.css";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { user } = await register(email, password, name);
      nav(routeForUser(user));
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Sign up failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="cts-scope">
      <div className="login-wrap">
        <form className="login-card" onSubmit={submit} data-testid="signup-form">
          <div className="brand"><div className="glyph" /><div className="name">Studio <span>/ CloudTV</span></div></div>
          <h1>Request access</h1>
          <p>Use your <b>company email</b>. New companies are reviewed before your team can join.</p>
          {err && <div className="login-err" data-testid="signup-error">{err}</div>}
          <div className="field">
            <label>Full name</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} data-testid="signup-name" placeholder="Jane Doe" />
          </div>
          <div className="field">
            <label>Work email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signup-email" spellCheck={false} placeholder="you@company.com" />
          </div>
          <div className="field">
            <label>Password <span className="hint-inline">min 8 characters</span></label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signup-password" />
          </div>
          <button className="btn primary block" type="submit" disabled={loading} data-testid="signup-submit">
            {loading ? "Creating…" : "Create account"}
          </button>
          <div className="or-sep"><span>or</span></div>
          <GoogleButton label="Sign up with Google" />
          <p className="login-foot">Already have an account? <Link to="/login" data-testid="to-login">Sign in</Link></p>
        </form>
      </div>
    </div>
  );
}
